import { api } from 'API/axios';
import { addImposterToUrl } from 'Utils';

const baseURL = '/MenuItems';

export interface IBurgerMenuItem {
  description: string;
  id: number;
  iconUrl: string;
  mobileIconUrl: string;
  internalLink?: string;
  externalLink?: string;
  isNewItem: boolean;
  subItems?: IBurgerMenuItem[];
}

export const getBurgerMenuItems = async () => {
  const burgerMenuItems = await api.get<IBurgerMenuItem[]>(
    addImposterToUrl(`${baseURL}`, true)
  );
  if (burgerMenuItems.data) return burgerMenuItems.data;
};
